module.exports = __webpack_public_path__ + "static/media/company_logo.2af5d7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_logo.png
// module id = 23
// module chunks = 0